<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import useRangeSections from "@/scripts/Utilities/RangeSections.js";
import SelectCourse from "@/components/Dashboard/Utilities/Config/SelectCourse.vue";
import FileInput from "@/components/Dashboard/Utilities/MapFlags/FileInput.vue";
import RangeSectionsTable from "@/components/Dashboard/Utilities/RangeSections/RangeSectionsTable.vue";

const {
  course,
  file,
  loading,
  loadingRangeSections,
  isFormValid,
  uploadRangeSections,
  openRangeSectionsModal,
  openRangeSectionsTableModal,
} = useRangeSections();
</script>

<template>
  <ContentHeader name="Range Sections Upload" :middleDots="true" />
  <section class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="form-group">
            <div class="ml-2">
              <SelectCourse v-model="course" />
            </div>
            <FileInput v-model="file" :accept="'.kml'" :label="'CHOOSE FILE'" />
            <br />

            <div class="input-group input-group-md">
              <button
                @click="uploadRangeSections"
                type="button"
                class="btn m-1 btn-info tm-btn-red fixed-width-button"
                :disabled="!isFormValid || loading"
              >
                <font-awesome-icon
                  v-show="loading"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loading">UPLOAD RANGE SECTIONS</span>
              </button>
              <button
                @click="openRangeSectionsTableModal"
                type="button"
                class="btn m-1 btn-info tm-btn-red fixed-width-button"
                :disabled="!course"
              >
                <font-awesome-icon
                  v-show="loadingRangeSections"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loadingRangeSections">VIEW RANGE SECTIONS</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <RangeSectionsTable
        :loading="loadingRangeSections"
        v-model="openRangeSectionsModal"
      />
    </div>
  </section>
</template>

<style scoped>
.fixed-width-button {
  width: 180px;
}
</style>
